import { Door, PencilSimple, Ruler, Stairs } from '@phosphor-icons/react';
import { ImmoButton, InnenKarte, KartenTitel, KpiReihe, KpiTile } from '../../../../../components/immobilien/ui';
import { eur, qm } from '../../../../../lib/immobilien/format';
import { useEinheitSeite } from '../EinheitSeitenKontext';
import { DatenZeile } from './teile';

const zahl = (v: unknown): number => { const x = Number(String(v ?? '').replace(',', '.')); return Number.isFinite(x) ? x : 0; };

/** „Fläche & Räume“: Eckdaten der Einheit wie in der bisherigen Ansicht; Ändern im Einheiten-Formular. */
export function FlaecheBereich() {
  const s = useEinheitSeite();
  const e = s.daten.einheit;
  const wohn = zahl(e.wohnflaeche);
  const nutz = zahl(e.nutzflaeche);
  const zimmer = zahl(e.zimmer);
  const proQm = s.flaeche > 0 && s.miete.kalt > 0 ? Math.round((s.miete.kalt / s.flaeche) * 100) / 100 : null;
  return (
    <>
      <KpiReihe>
        <KpiTile label="Wohnfläche" wert={wohn > 0 ? qm(wohn) : '–'} sub={nutz > 0 ? `Nutzfläche ${qm(nutz)}` : 'keine Nutzfläche'} icon={Ruler} ton="acc" />
        <KpiTile label="Zimmer" wert={zimmer > 0 ? zimmer.toLocaleString('de-DE') : '–'} sub={(e.etage ?? '').trim() || 'Lage nicht erfasst'} icon={Door} />
        <KpiTile label="Kaltmiete / m²" wert={proQm !== null ? eur(proQm) : '–'} sub={proQm !== null ? `bei ${eur(s.miete.kalt)} kalt` : s.aktuell ? 'Fläche fehlt' : 'Leerstand'} icon={Stairs} />
      </KpiReihe>
      <InnenKarte>
        <KartenTitel>Eckdaten</KartenTitel>
        <div className="flex flex-col">
          <DatenZeile label="Art" wert={(e.typ ?? '').trim() || s.artLabel} />
          <DatenZeile label="Lage / Geschoss" wert={(e.etage ?? '').trim()} />
          <DatenZeile label="Wohnfläche" wert={wohn > 0 ? qm(wohn) : ''} zahl />
          <DatenZeile label="Nutzfläche" wert={nutz > 0 ? qm(nutz) : ''} zahl />
          <DatenZeile label="Zimmer" wert={zimmer > 0 ? zimmer.toLocaleString('de-DE') : ''} zahl />
        </div>
        <ImmoButton icon={PencilSimple} onClick={() => s.bearbeiteEinheit('einheit')} style={{ alignSelf: 'flex-start' }}>Eckdaten ändern</ImmoButton>
      </InnenKarte>
    </>
  );
}
